import type { BoxShadowType } from '@vedalib/editor/lib/brand'
import cn from 'classnames'

import type { IFieldChange, IFieldMeta } from 'components/formKit/types'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'
import { testPropsEl } from 'utils/test/qaData'

import * as s from './Presets.module.scss'
import IconNone from './none.svg?react'

export const PRESETS = [
  {
    key: 'none' as const,
    icon: <IconNone />,
    label: t('input.label.shadow.none'),
    boxShadow: 'none',
  },
  {
    key: 'soft' as const,
    label: t('input.label.shadow.soft'),
    boxShadow: '0px 0px 10px 0px #1B1B1B1A',
  },
  {
    key: 'regular' as const,
    label: t('input.label.shadow.regular'),
    boxShadow: '6px 6px 6px 0px #1B1B1B1A',
  },
  {
    key: 'retro' as const,
    label: t('input.label.shadow.retro'),
    boxShadow: '2px 2px 0px 0px #1B1B1B1A',
  },
]

interface IPresetsProps {
  name: string
  preset: BoxShadowType['preset']
  onChange: (value: IFieldChange<string, IFieldMeta>) => void
  onChangePreset: (preset: BoxShadowType['preset']) => void
  disabled?: boolean
  brand?: boolean
}

const Presets: React.FC<IPresetsProps> = ({ name, onChange, preset, brand, onChangePreset }) => {
  const handleBrandReset = () => onChange({ value: 'var(--brand-boxShadow)', name })

  return (
    <div className={s.root}>
      {PRESETS.map(({ key, label, boxShadow, icon }) => (
        <div
          {...testPropsEl('shadowRadio', { name: `${name}-${key}`, value: preset === key })}
          className={cn(s.item, { [s.selected]: preset === key })}
          key={key}
          onClick={() => onChangePreset(key)}
        >
          <div className={s.preview} style={{ boxShadow }}>
            {icon}
          </div>
          <Typography styleType='hint'>{label}</Typography>
        </div>
      ))}
      {brand && (
        <div
          {...testPropsEl('shadowRadio', { name: `${name}-BRAND`, value: 'BRAND' })}
          className={cn(s.item)}
          onClick={handleBrandReset}
        >
          <div className={s.preview} style={{ boxShadow: 'var(--brand-boxShadow)' }} />
          <Typography styleType='hint'>{t('input.label.brand')}</Typography>
        </div>
      )}
    </div>
  )
}

export default Presets
